import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { ApiError, ApiResult } from '@models/api';

function useRGetApplicationData<TData>(
  options: UseQueryOptions<ApiResult<TData>, ApiError> & { page: number } = {
    page: 1,
  },
) {
  const { page, enabled, ...resOptions } = options;

  return useQuery({
    queryKey: ['application/form', { page }],
    enabled,
    ...resOptions,
  });
}

export default useRGetApplicationData;
